"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviousSessionIndexBuilder = void 0;
const createFingerprints_1 = require("../createFingerprints");
class PreviousSessionIndexBuilder {
    #index = {
        previousUniqueUrls: new Set(),
        previousViolationsMap: new Map(),
        rules: new Map(),
        fingerprints: new Set(),
        pageStates: 0
    };
    add(pageState) {
        this.#index.pageStates++;
        for (const ruleResult of pageState.result) {
            let rule = this.#index.rules.get(ruleResult.id);
            let ruleFingerprints = this.#index.previousViolationsMap.get(ruleResult.id);
            if (!rule || !ruleFingerprints) {
                rule = { impact: ruleResult.impact, nodes: [] };
                ruleFingerprints = new Set();
                this.#index.rules.set(ruleResult.id, rule);
                this.#index.previousViolationsMap.set(ruleResult.id, ruleFingerprints);
            }
            for (const unique of ruleResult.uniques) {
                this.#index.previousUniqueUrls.add(unique.url);
                rule.nodes.push(unique.fingerprints);
                unique.fingerprints?.forEach(f => this.#index.fingerprints.add(f));
                if (unique.target && unique.target.length) {
                    (0, createFingerprints_1.createFingerprints)({ ruleId: ruleResult.id, node: unique }).forEach(f => ruleFingerprints.add(f));
                }
            }
        }
    }
    build() {
        return this.#index;
    }
}
exports.PreviousSessionIndexBuilder = PreviousSessionIndexBuilder;
//# sourceMappingURL=previousSessionIndex.js.map